module.exports = __webpack_public_path__ + "1743c38152ac204544227f0cf674ccb0.png";